import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const BogIcon = observer(
    'BogIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => (
        <SvgIcon
            className={className}
            onClick={onClick}
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.133 9.66659L13.6663 7.49992L15.6663 7.66659L12.733 10.2166L13.5997 13.9999L11.8997 12.9666L11.133 9.66659ZM9.56634 4.79992L8.86634 3.16659L9.63301 1.33325L11.1663 4.94992L9.56634 4.79992ZM2.88301 13.9999L3.96634 9.31659L0.333008 6.16659L5.13301 5.74992L6.99967 1.33325L8.86634 5.74992L13.6663 6.16659L10.033 9.31659L11.1163 13.9999L6.99967 11.5166L2.88301 13.9999Z'
                fill='#1C1B1F'
            />
        </SvgIcon>
    )
);
